import { render, staticRenderFns } from "./ReleaseDistribution.vue?vue&type=template&id=27fa1fa1&scoped=true&"
import script from "./ReleaseDistribution.vue?vue&type=script&lang=js&"
export * from "./ReleaseDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDistribution.vue?vue&type=style&index=0&id=27fa1fa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa1fa1",
  null
  
)

export default component.exports